<template>
<b-row>
    <b-colxx xxs="12">
        <h1>{{ $t('menu.messageSend') }}</h1>
        <piaf-breadcrumb />
        <b-row>
            <b-colxx xxs="8">
                <b-card class="mb-4" title="전송 정보 입력">
                    <b-form-group label-cols="2" horizontal label="제목" class="weight600">
                        <b-form-textarea v-model="message.title" :rows="1" :max-rows="1" />
                    </b-form-group>
                    <b-form-group label-cols="2" horizontal label="입력창" class="weight600">
                        <b-form-textarea v-model="message.content" :rows="4" :max-rows="4" :maxlength="1000" />
                        <span>{{ message.content.length }} / 1000 </span>
                    </b-form-group>
                    <div class="text-center">
                        <b-button variant="primary" @click.prevent="sendMessage">전송하기</b-button>
                    </div>
                </b-card>
            </b-colxx>
            <b-colxx xxs="4">
                <b-card class="mb-4" title="메시지 전송 대상">
                    <!-- <b-form-radio-group v-model="target">
                        <b-form-radio :value="false">타겟 설정 안함( 전체 고객 대상 발송 )</b-form-radio>
                    </b-form-radio-group> -->
                    <span>전체 고객 대상 발송</span>
                    <b-form-group label-cols="4" horizontal label="대상" class="weight600 mt-5 mb-0">
                        <p style="padding-top: 5px;"> 전체고객 </p>
                    </b-form-group>
                    <b-form-group label-cols="4" horizontal label="총 예상 발송 대상" class="weight600">
                        <p style="padding-top: 5px;">{{ userTotalElements + bookingSmsCount + '명' }}</p>
                    </b-form-group>
                </b-card>
            </b-colxx>
        </b-row>
    </b-colxx>
</b-row>
</template>

<script>
import api from '../../constants/api';

import {
    rescode,
} from "../../constants/common";
import {
    reqGet,
    reqPost
} from "../../constants/request";
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";

export default {
    computed: {
        ...mapGetters(['currentUser', 'siteName', 'brandInfo'])
    },

    data() {
        return {
            message: {
                content: '',
                title: '',
            },
            target: false,
            totalTarget: 0,
            centerNumber: '',
            userTotalElements: 0,
            bookingSmsCount: 0,
            maxByte: 3000,
        }
    },
    mounted() {
        this.getMessageInfo()
    },
    methods: {
        getMessageInfo() {
            reqGet(
                api.changeAPI(this.siteName, api.basicURL + api.siteSet.siteInfoData),
                this.currentUser.tokens.access.token,
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.centerNumber = result.data.siteInfo.centerNumber;
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
            reqGet(
                api.changeAPI(this.siteName, api.basicURL + api.message.sms_list_page),
                this.currentUser.tokens.access.token,
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.userTotalElements = result.data.totalElements;
                        } else {
                            alert(result.message);
                        }
                    }
                }
            );

            reqPost(
                api.changeAPI(this.siteName, api.basicURL + api.message.bookingSmsCount),
                this.currentUser.tokens.access.token, {
                    // brandCode: this.brandInfo.brandCode,
                },
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {
                            this.bookingSmsCount = result.data;

                        } else {

                        }
                    }
                }
            );
        },
        sendMessage() {
            if (this.message.content.length === 0) {
                alert('내용을 입력 해주세요.');
                return;
            } else if ((this.userTotalElements + this.bookingSmsCount) === 0) {
                alert('발송 대상이 0명 입니다.');
                return;
            }
            reqPost(
                api.changeAPI(this.siteName, api.basicURL + api.message.marketing_message),
                this.currentUser.tokens.access.token, {
                    centerNumber: "16003662",
                    brandCode: this.brandInfo.brandCode,
                    siteName: this.siteName,
                    message: this.message.content,
                    title: this.message.title,
                },
                (result) => {
                    if (result != null) {
                        if (result.code == rescode.REQ_SUCCESS) {

                            alert('전송 완료');
                            this.$router.push('messageSent');

                        } else {
                            alert(result.message);
                        }
                    }
                }
            );
        },
    },
}
</script>

<style>

</style>
